module.exports = __webpack_public_path__ + "img/Prod.aa5f368d.png";